<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View Step Hazard/Risk</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <ng-container *ngIf="ta_revised_workflow_hazard.name">
    <h6>Hazard/Risk</h6>
    <p id="name">{{ ta_revised_workflow_hazard.name }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.description">
    <h6>Description</h6>
    <p id="description" class="white-space-pre-wrap">{{ ta_revised_workflow_hazard.description }}</p>
  </ng-container>

  <ng-container>
    <h6>Significant</h6>
    <p id="significant">{{ ta_revised_workflow_hazard.significant ? 'Yes' : 'No' }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.status">
    <h6>Status</h6>
    <p id="status">{{ ta_revised_workflow_hazard.status }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.ira_likelihood && ta_revised_workflow_hazard.ira_severity">
    <h6>Initial Risk Assessment Score</h6>
    <p id="ira_score">
      <span [class]="utils.getSiteRiskStatusTextColor(ta_revised_workflow_hazard.ira_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity))">
        {{ ta_revised_workflow_hazard.ira_score ?? utils.calculateRiskScore(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.ira_likelihood && ta_revised_workflow_hazard.ira_severity">
    <h6>Initial Risk Assessment</h6>
    <p id="ira">
      <span [class]="utils.getSiteRiskStatusTextColor(ta_revised_workflow_hazard.ira_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity))">
        {{ ta_revised_workflow_hazard.ira_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.ira_likelihood, ta_revised_workflow_hazard.ira_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.rra_likelihood && ta_revised_workflow_hazard.rra_severity">
    <h6>Residual Risk Assessment Score</h6>
    <p id="rra_score">
      <span [class]="utils.getSiteRiskStatusTextColor(ta_revised_workflow_hazard.rra_score_band ?? utils.getRiskAssessmentText(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity))">
        {{ ta_revised_workflow_hazard.rra_score ?? utils.calculateRiskScore(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.rra_likelihood && ta_revised_workflow_hazard.rra_severity">
    <h6>Residual Risk Assessment</h6>
    <p id="rra">
      <span [class]="utils.getSiteRiskStatusTextColor(utils.getRiskAssessmentText(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity))">
        {{ utils.getRiskAssessmentText(ta_revised_workflow_hazard.rra_likelihood, ta_revised_workflow_hazard.rra_severity) }}
      </span>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.controls.length">
    <h6>Hazard/Risk Controls</h6>
    <p id="controls" *ngFor="let control of ta_revised_workflow_hazard.controls; let i = index">
      <ng-container *ngIf="control && control?.control && control?.loc">
        <b>{{ i + 1 }} - {{ control.control }}</b> <br />
        {{ loc_list[control.loc - 1] }}
      </ng-container>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.reviewer">
    <h6>Reviewer</h6>
    <p id="reviewed-by">
      <a (click)="onUserPublicView(ta_revised_workflow_hazard.reviewer.hash)"
        matTooltip="View User Public Profile">
        {{ ta_revised_workflow_hazard.reviewer.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.reviewer_date">
    <h6>Review Date</h6>
    <p id="reviewed-date">{{ ta_revised_workflow_hazard.reviewer_date * 1000 | timezoneConvertMedium }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.last_reviewer_date">
    <h6>Last Review Date</h6>
    <p id="last-reviewed-date">{{ ta_revised_workflow_hazard.last_reviewer_date * 1000 | date:'medium' }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.reference">
    <h6>Reference</h6>
    <p id="reference">
      <b>ID #:</b> {{ ta_revised_workflow_hazard.reference_id }} <br />
      <b>Hazard/Risk Name:</b> {{ ta_revised_workflow_hazard.reference.name }} <br />
      <b>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}:</b> {{ ta_revised_workflow_hazard.reference.site.name }}
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.created_by_user">
    <h6>Created By</h6>
    <p>
      <a (click)="onUserPublicView(ta_revised_workflow_hazard.created_by_user.hash)"
        matTooltip="View User Public Profile">
        {{ ta_revised_workflow_hazard.created_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.date_created">
    <h6>Created At</h6>
    <p>{{ ta_revised_workflow_hazard.date_created * 1000 | timezoneConvertMedium }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.updated_by_user">
    <h6>Last Updated By</h6>
    <p>
      <a (click)="onUserPublicView(ta_revised_workflow_hazard.updated_by_user.hash)"
        matTooltip="View User Public Profile">
        {{ ta_revised_workflow_hazard.updated_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.date_modified">
    <h6>Last Updated At</h6>
    <p>{{ ta_revised_workflow_hazard.date_modified * 1000 | timezoneConvertMedium }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised_workflow_hazard.files?.length">
    <h6>Files</h6>
    <app-files-list
      id="files"
      [files]="ta_revised_workflow_hazard.files"
      [view]="true">
    </app-files-list>
  </ng-container>
</mat-dialog-content>
